(function(){
  document.addEventListener('click',function(e){
    var btn=e.target;
    while(btn&&btn!==document){
      if(btn.getAttribute&&btn.getAttribute('name')==='add')break;
      if(btn.tagName==='BUTTON'&&btn.type==='submit'&&btn.closest&&btn.closest('form[action*="/cart/add"]'))break;
      btn=btn.parentNode;
    }
    if(!btn||btn===document)return;
    var form=btn;
    while(form&&form!==document){
      if(form.tagName==='FORM')break;
      form=form.parentNode;
    }
    if(!form||form===document)return;
    var action=form.getAttribute('action')||'';
    if(action.indexOf('/cart/add')===-1)return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    fetch('/cart/add.js',{method:'POST',body:new FormData(form)}).then(function(){
      window.location.href='/checkout';
    }).catch(function(){
      window.location.href='/checkout';
    });
  },true);
})();